import React from 'react';
import styles from './style.module.scss';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default class StatPanel extends React.Component {
    static propTypes = {
        cardDeck: ImmutablePropTypes.list.isRequired,
        cardsOut: ImmutablePropTypes.list,
        cardsClickedOn: ImmutablePropTypes.list,
        cardsUsed: ImmutablePropTypes.list,

        newGame: PropTypes.func.isRequired,
        checkSet: PropTypes.func.isRequired,

        playerOneCorrect: PropTypes.number,
        playerOneErrors: PropTypes.number,
        playerTwoCorrect: PropTypes.number,
        playerTwoErrors: PropTypes.number,
    };

    render() {
        return (
            <div className={styles.border_of_stat}>
                <input className={styles.setting_button}
                    alt="setting_button"
                    type="image"
                    src="img/settings.png"
                    width="25"
                    height="25"
                >
                </input>
                <div className={styles.hints_please}>
                    <button type="button">2 Card Hint</button>
                    <button type="button">1 Card Hint</button>
                    <button type="button" onClick={() => { this.props.newGame() }}>New Game</button>
                </div>
                <div className={styles.stat_holder}>
                    <button type="button" className={styles.player_header_button} onClick={() => { this.props.checkSet(1) }}>Player 1</button>
                    <ul className={styles.player_list_stats}>
                        <li> Correct: {this.props.playerOneCorrect}</li>
                        <li> Errors: {this.props.playerOneErrors}</li>
                        <li> Points: {this.props.playerOneCorrect * 3 - this.props.playerOneErrors * 2}</li>
                    </ul>
                </div>
                <div className={styles.stat_holder}>
                    <button type="button" className={styles.player_header_button} onClick={() => { this.props.checkSet(2) }}>Player 2</button>
                    <ul className={styles.player_list_stats}>
                        <li> Correct: {this.props.playerTwoCorrect}</li>
                        <li> Errors: {this.props.playerTwoErrors}</li>
                        <li> Points: {this.props.playerTwoCorrect * 3 - this.props.playerTwoErrors * 2}</li>
                    </ul>
                </div>
                <div className={styles.stat_holder}>
                    <h1>Search</h1>
                    <ul className={styles.search_list_stats}>
                        <li> Solutions:</li>
                        <li> BT: </li>
                        <li> NV: </li>
                        <li> CC: </li>
                        <li> CPU Time: </li>
                    </ul>
                </div>
                <div className={styles.stat_holder}>
                    <h1>Reformulation</h1>
                    <ul className={styles.search_list_stats}>
                        <li> Solutions:</li>
                        <li> BT: </li>
                        <li> NV: </li>
                        <li> CC: </li>
                        <li> CPU Time: </li>
                    </ul>
                </div>
            </div>
        )
    }
}